"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../../../utils");
var _point_black = _interopRequireDefault(require("../../../../../../assets/png/point_black.png"));
var _icons = require("../../../../../icons");
var _resizableText = _interopRequireDefault(require("./resizable-text"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ContentSlide = function ContentSlide(_ref) {
  var content = _ref.content,
    showProfile = _ref.showProfile,
    hasHighlight = _ref.hasHighlight;
  var contentCountryCity = content.countryCity ? "".concat(content.countryCity, ", ").concat(content.countryName) : "".concat(content.countryName);
  var contentCityName = content.cityName ? "".concat(content.cityName, ", ").concat(content.state) : "".concat(content.state);
  var location = content.international ? contentCountryCity : contentCityName;
  var deletePeriod = function deletePeriod(text) {
    var textWithoutPeriod = text;
    var lastCharacter = textWithoutPeriod.charAt(textWithoutPeriod.length - 1);
    while (lastCharacter === '.') {
      var newText = textWithoutPeriod.slice(0, -1);
      textWithoutPeriod = newText;
      lastCharacter = newText.charAt(textWithoutPeriod.length - 1);
    }
    return textWithoutPeriod;
  };
  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    key: 1
  }, /*#__PURE__*/_react.default.createElement(_styled.Content, null, content.company && /*#__PURE__*/_react.default.createElement(_resizableText.default, null, deletePeriod(content.company)), content.group && /*#__PURE__*/_react.default.createElement(_resizableText.default, null, deletePeriod(content.group)), /*#__PURE__*/_react.default.createElement(_styled.Description, null, deletePeriod(content.position), /*#__PURE__*/_react.default.createElement("br", null), "".concat(location, " | ").concat((0, _utils.getExperienceSubtitle)(content)))), /*#__PURE__*/_react.default.createElement(_styled.WrapperList, null, content.lines && content.lines.filter(function (line) {
    return line.enabled === 1;
  }).length > 0 && /*#__PURE__*/_react.default.createElement(_styled.List, {
    showProfile: showProfile
  }, content.lines.filter(function (line) {
    return line.high !== 2;
  }).map(function (line) {
    return line.value && /*#__PURE__*/_react.default.createElement(_styled.ListItem, {
      key: line.id,
      showProfile: showProfile
    }, /*#__PURE__*/_react.default.createElement(_styled.WrapperPoint, null, hasHighlight && line.isHighlighted ? /*#__PURE__*/_react.default.createElement(_icons.IconButton, {
      hasAction: false,
      icon: _icons.CheckIcon,
      iconProps: {
        color: 'black',
        width: 14,
        height: 14
      },
      bsStyle: {
        alignSelf: 'flex-start'
      }
    }) : /*#__PURE__*/_react.default.createElement(_styled.BulletPoint, {
      src: _point_black.default,
      alt: "point"
    })), deletePeriod(line.value));
  }))));
};
ContentSlide.propTypes = {
  content: _propTypes.default.shape({
    company: _propTypes.default.string,
    group: _propTypes.default.string,
    position: _propTypes.default.string,
    stateName: _propTypes.default.string,
    cityName: _propTypes.default.string,
    state: _propTypes.default.string,
    startMonth: _propTypes.default.string,
    startYear: _propTypes.default.string,
    endMonth: _propTypes.default.string,
    endYear: _propTypes.default.string,
    international: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
    countryCity: _propTypes.default.string,
    countryName: _propTypes.default.string,
    lines: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    isHighlighted: _propTypes.default.number
  }),
  showProfile: _propTypes.default.bool,
  hasHighlight: _propTypes.default.bool
};
ContentSlide.defaultProps = {
  content: {
    international: false
  },
  showProfile: false,
  hasHighlight: false
};
var _default = ContentSlide;
exports.default = _default;